import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';

declare let $: any;
declare let Swal: any;

@Component({
    selector : 'room-user-screen',
    templateUrl:'room-user-screen-component.html'
})
export class RoomUserScreenComponent implements OnInit, OnDestroy{
  public admin=false;
  public contacts;
  public meeting=false;
  public company=false;
  public companyLabel='Usuarios da Empresa'
  public tempSearch=[]
  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this.contacts=[];
    this.searchUsers();
  }
  public searchUsers(){
    if (this.company){
      this._companyService.getUsersFromCompany(this._appData.room.company).get().then(v=>{
        v.forEach(us=>{
          let user=us.data();
          this.contacts.push(user)
        })
        
      })
    }
    else{
      this._companyService.getUserRoomPosition(this._appData.room.id).get().then(val=>{
        val.forEach(v=>{
          let user=v.data();
          let number=Number(user.uid);
  
          if (isNaN(number)){
            this._companyService.getUserByUid(user.uid).then(u=>{
            this.contacts.push(u.data())
  
            })
          }
        })
  
      })
  
    }

  }
  public openChat(contact){
    this._appData.talkTo=contact;
    this._appData.cellScreen='chat'
    setTimeout(()=>{
      $('#cellChatReload').click()
    },1000)
  }
  public openConference(contact){
    Swal.fire({
      title:"Chamada por vídeo",
      text:"Você deseja convidar esse usuário para falar contigo por videoconferência?",
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:'Não',
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,"Pedido de videoconferência",this._appData.instagramUser.full_name+" está te convidando para ir para conversar por videoconferência. Você aceita?","newCellJitsi","",false)
        Swal.fire({
          title:'Convite enviado',
          message: contact.full_name+' foi convidado para conversar contigo. Aguarde resposta.'
        });
      }
    });       
  }
  public goto(contact){
    Swal.fire({
      title:"TELEPORTE",
      text:"Você deseja convidar esse usuário a se teleportar para onde você está?",
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:'Não',
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,"Pedido de teleporte",this._appData.instagramUser.full_name+" está te convidando para ir para o local onde está. Você deseja ir?","newCellTeleport",this._appData.instagramUser.position.x+'-'+this._appData.instagramUser.position.y,false)
        Swal.fire({
          title:'Convite enviado',
          message: contact.full_name+' foi convidado para se teleportar para onde você se encontra. Aguarde resposta.'
        });
      }
    });       
  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
  }

  public ngOnDestroy() : any {
  }

  public kick(contact){
    Swal.fire({
      title:'Remover usuário da sala',
      text:'Você deseja remover '+contact.full_name+' da sala?',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:'Não',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        let date=new Date();
        let time=date.getTime();
        let name=this._appData.instagramUser.full_name;
        let notification={
          event:this._appData.event.id,
          time:time,
          senderUid:this._appData.instagramUser.uid,
          senderName:name,
          senderThumbnail:'',
          subject:'Você foi chutado',
          message:name +' lhe removeu da sala',
          kind:'kick',
          link:contact.uid,
          read:false,
          action:'',
          answer:''
        }
        this._companyService.addRoomNotification(this._appData.room,notification) 
      }
    })

  }
  
  public notifyRegister(contact){
    let date=new Date();
    let time=date.getTime();
    let name=this._appData.instagramUser.full_name;
    let notification={
      event:this._appData.event.id,
      time:time,
      senderUid:this._appData.instagramUser.uid,
      senderName:name,
      senderThumbnail:'',
      subject:'Pedido de cadastro',
      message:'Você deseja se cadastar?',
      kind:'registerNotification',
      link:contact.uid,
      read:false,
      action:'',
      answer:''
    }
    this._companyService.addRoomNotification(this._appData.room,notification) 
    Swal.fire({title:'Pedido enviado',message:'Usuário recebeu seu pedido'})
  }
  public notifyAvatar(contact){
    let date=new Date();
    let time=date.getTime();
    let name=this._appData.instagramUser.full_name;
    let notification={
      event:this._appData.event.id,
      time:time,
      senderUid:this._appData.instagramUser.uid,
      senderName:name,
      senderThumbnail:'',
      subject:'Mudar Avatar',
      message:'Você deseja mudar seu avatar?',
      kind:'avatarChange',
      link:contact.uid,
      read:false,
      action:'',
      answer:''
    }
    this._companyService.addRoomNotification(this._appData.room,notification)   
    Swal.fire({title:'Pedido enviado',message:'Usuário recebeu seu pedido'})

  }
  public cameraFix(contact){
    let date=new Date();
    let time=date.getTime();
    let name=this._appData.instagramUser.full_name;
    let notification={
      event:this._appData.event.id,
      time:time,
      senderUid:this._appData.instagramUser.uid,
      senderName:name,
      senderThumbnail:'',
      subject:'Pedido de fix camera',
      message:'Pede para voce autorizar mudar a camera',
      kind:'cameraFix',
      link:contact.uid,
      read:false,
      action:'',
      answer:''
    }
    this._companyService.addRoomNotification(this._appData.room,notification) 
    Swal.fire({title:'Pedido enviado',message:'Usuário recebeu seu pedido'})

  }
  public ban(contact){
    let admin=false;
    if (this._appData.event.admins){
      this._appData.event.admins.forEach((val)=>{
        if (val==this._appData.instagramUser.uid){
          admin=true;
          this._appData.instagramUser.vip=true;
        }
      }) 
    }
    if (admin){
      Swal.fire({
        title:'Banir usuário da sala',
        text:'Você deseja banir '+contact.full_name+' da sala?',
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:'Não',
        showCancelButton: true,
        showCloseButton: true,
        preConfirm: () => {
          this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},'Banimento',this._appData.instagramUser.full_name+' te baniu da sala.','ban',null,null)
        }
      })  
    }
    else{
      Swal.fire({
        title:'Banir usuário da sala',
        text:'Você não é um administrador da sala. Apenas administradores podem banir usuários.'
      })  

    }

  }

  public yoink(contact){
    Swal.fire({
      title:'Chamar atenção',
      text:'Você deseja chamar a atenção de '+contact.full_name+'? Ele vai ouvir um som para abrir o liveplanet',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:'Não',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,contact,'Yoink',this._appData.instagramUser.full_name+' chamou sua atenção.','Yoink',0,null)
      }

    })

  }
  public doSearch(event: any){
    let input=$("#roomUserSearchInput").val();
    let upper=input.toUpperCase();
    if (upper==''){
      this.searchUsers();
    }
    else{
      if (this.tempSearch==null || this.tempSearch.length==0){
        this.tempSearch=this.contacts
      }
      this.contacts=this.tempSearch.filter(v=>{
        return (v.full_name.toUpperCase().indexOf(upper)>=0)
      })
    }

  }
  public teleport(contact){
    this._companyService.getUserByUid(contact.uid).then(
      v=>{
        let userContact=v.data();
        if (this._appData.instagramUser){
          Swal.fire({
            title: this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
            text:this.translate.instant('CONTACT_SCREEN_COMPONENT_15a'),
            confirmButtonText: this.translate.instant('YES'),
            cancelButtonText:this.translate.instant('NO'),
            showCancelButton: true,     
            showCloseButton: true,
          }).then((result) => {
            if (result.value) {
              if (this._appData.room.id==userContact.room){
                this._companyService.getUserRoomPosition(userContact.room).doc(userContact.uid).get().then(s=>{
                  let contact=s.data();
                  if (contact){
                    this.sendIframeMessage({
                      kind:'updateUserStatus',
                      params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:contact.x,y:contact.y}}
                    });        
                  }
                  else{
                    Swal.fire({title:"Usuário Deslogado",text:"Esse usuário não está logado para você se teleportar."})
                  }
  
                })
              }
              else{
                this._companyService.getUserRoomPosition(userContact.room).doc(userContact.uid).get().then(s=>{
                  let contact=s.data();
                  if (contact){
                    let room=userContact.room;
                    Swal.fire({
                    title:"Usuário em outra sala",
                      text:"Teremos que te enviar para outra sala onde o usuário está. Você deseja ir?",
                      confirmButtonText: this.translate.instant('YES'),
                      cancelButtonText:this.translate.instant('NO'),
                      showCancelButton: true,     
                      showCloseButton: true,
                    }).then((result) => {
                      let domain=window.location.origin
                      window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+room;
      
                      }
                    )
                  }
                  else{
                    Swal.fire({title:"Usuário Deslogado",text:"Esse usuário não está logado para você se teleportar."})
                  }
                })


              }
                
              }
          });    
        }
        else{
          $('#registerSocialModal').modal('show'); 
          this._appData.tiping=true;
        }
    
      }
    )

  }
  public switchCompany(){
    if (this.company){
      this.companyLabel='Usuários da empresa'

    }
    else{
      this.companyLabel='Usuários da sala'

    }
    this.company=!this.company;
    this.contacts=[]
    this.searchUsers();
    this.tempSearch=[]
    
  }
  public sendIframeMessage(messageKind){
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }

  public askContact(contact){
    let askId=contact.uid;
    let name=contact.full_name;
    this._companyService.checkContacts(this._appData.instagramUser,{uid:askId,full_name:''}).get().then(val=>{
      let user=val.data();
      if (user){
        Swal.fire({
          title:'Pedir contato',
          text:'Você já possui esse contato no seu celular interno. Você pode falar com ele ou chamar para uma videoconferência privada por lá.',
          confirmButtonText: 'OK',
          showCloseButton: true,
          preConfirm: () => {
            this._appData.cellScreen='profile'
            this._appData.talkTo={uid:askId,full_name:name};
          }   
        })
      }
      else{
        Swal.fire({
          title:'Pedir contato',
          text:'Você deseja pedir contato de '+name+' para adicionar na sua lista de contatos? Se '+name+' aceitar você receberá 100 pontos de popularidade. Caso seu pedido não seja aceito você perderá 10 pontos. Você pode pedir a qualquer momento. Deseja pedir?',
          confirmButtonText: this.translate.instant('YES'),
          cancelButtonText:'Não',
          showCancelButton: true,
          showCloseButton: true,
          preConfirm: () => {
            this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:askId,full_name:name},'Pedido de Contato',this._appData.instagramUser.full_name+' pediu seu contato. Você aceita dar seu contato com acesso a seu email e telefone? Se aceitar você recebe 50 pontos de popularidade.','askContact',null,null)
          }
    
        })
    
      }

    })

  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/room-user-screen/room-user-screen-component.ts